import React from "react";
import {
  GallopItem,
  GroupedTraining,
} from "../../shared/types/gallopData.type";
import { Box, Stack, Typography } from "@mui/material";
import SplitsTable from "./SplitsTable";
import KeyParamTable from "./KeyParamTable";
import { t } from "i18next";
import styled from "styled-components";
import palette from "../../theme/palette";

type GallopGroupsProps = {
  groups: GroupedTraining[];
  trainings: GallopItem[];
};

function GallopGroups({ groups, trainings }: GallopGroupsProps) {
  return (
    <>
      {groups.map((group, i) => (
        <Box
          key={i}
          display="block" // Ensures block formatting context
          sx={{
            // THE FIX IS HERE: Change 'avoid' to 'auto'
            pageBreakAfter: i !== groups.length - 1 ? "always" : "auto",
          }}
        >
          <RenderPageTitle title={group?.name || ""} />

          {/* Add padding bottom to main container to clear the footer visual space */}
          <Stack spacing={1} p={1} sx={{ paddingBottom: "30px" }}>
            <Typography fontSize={20} fontWeight={600}>
              {t("gallop:splitsTable")}
            </Typography>
            <Typography color={"gray"} variant="caption">
              {t("splits:explication2")}
            </Typography>

            <SplitsTable
              data={group.trainings}
              allSameDate={false}
              showMetadata={group.display_metadata_column}
              isEmptyGroups={group.is_empty_group}
            />

            <Stack spacing={1} sx={{ breakInside: "avoid" }}>
              <Typography fontSize={20} fontWeight={600}>
                {t("keyParameters:title")}
              </Typography>
              <Typography color={"gray"} variant="caption">
                {t("gallop:explication1")}
              </Typography>
              <KeyParamTable
                data={group.trainings}
                allSameDate={false}
                showMetadata={group.display_metadata_column}
                isEmptyGroups={group.is_empty_group}
                avgParams={group.key_parameters_averages}
              />
            </Stack>
          </Stack>
          <Typography
            id="print-footer"
            variant="caption"
            sx={{
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              textAlign: "right",
              display: "none",
              fontSize: 10,
              color: "#999 !important",
              padding: "10px 20px",
              backgroundColor: "white",
              "@media print": { display: "block" },
            }}
          >
            <StyledFooterSpan
              dangerouslySetInnerHTML={{ __html: t("pdf:footer:title") }}
            />
          </Typography>
        </Box>
      ))}
    </>
  );
}

const RenderPageTitle = ({ title }: { title: string }) => {
  return (
    <Box
      display={"flex"}
      justifyContent={"space-between"}
      alignItems={"center"}
    >
      <div className="gallopTitle">
        <Typography fontSize={24} fontWeight={600} color={"white"}>
          {t("gallop:repportTitle")}
        </Typography>
        <Typography fontSize={18} fontWeight={400} color={"white"}>
          {title}
        </Typography>
      </div>
      <img
        style={{ objectFit: "contain", width: 55, height: 55, marginRight: 15 }}
        src="/arioneo_logo_white.png"
        alt="arioneo logo"
      />
    </Box>
  );
};

const StyledFooterSpan = styled("span")({
  color: "#999",
  "& a": {
    color: `${palette.dark.primary.main} !important`, // Your link color
    textDecoration: "none",
    "&:hover": {
      color: "#115293",
    },
  },
});

export default GallopGroups;
